import DashboardLayout from '@/pages/Layout/DashboardLayout.vue';
import AuthLayout from '@/pages/Layout/AuthLayout.vue';
import ProfileLayout from '@/pages/Layout/ProfileLayout.vue';
import CompanyLayout from '@/pages/Layout/CompanyLayout.vue';
import CompanyProfileLayout from '@/pages/Layout/CompanyProfileLayout.vue';
import ReportLayout from '@/pages/Layout/ReportLayout.vue';
import MarketProfileLayout from '@/pages/Layout/MarketProfileLayout.vue';
import MarketReportLayout from '@/pages/Layout/MarketReportLayout.vue';
import CompanyReportLayout from '@/pages/Layout/CompanyReportLayout.vue';
import VestimateReportLayout from '@/pages/Layout/VestimateReportLayout.vue';

// Sample pages
import SampleProfileLayout from '@/pages/Layout/SampleProfileLayout.vue';
import SampleMarketProfileLayout from '@/pages/Layout/SampleMarketProfileLayout.vue';
import SampleCompanyProfileLayout from '@/pages/Layout/SampleCompanyProfileLayout.vue';
import SampleFinancialReportLayout from '@/pages/Layout/SampleReportLayout.vue';
import SampleMarketReportLayout from '@/pages/Layout/SampleMarketReportLayout.vue';
import SampleCompanyReportLayout from '@/pages/Layout/SampleCompanyReportLayout.vue';
import SampleVestimateReportLayout from '@/pages/Layout/SampleVestimateReportLayout.vue';

// Dashboard pages
import Dashboard from '@/pages/Dashboard/Dashboard.vue';
import Search from '@/pages/Bizminer/Search/Search.vue';
import CompanySearch from '@/pages/Bizminer/Search/CompanySearch.vue';
import ProspectSearch from '@/pages/Bizminer/Search/ProspectSearch.vue';
import SearchList from '@/pages/Bizminer/Search/SearchList.vue';
import MyProfiles from '@/pages/Bizminer/Profiles/MyProfiles.vue';
import NewProfiles from '@/pages/Bizminer/Profiles/NewProfiles.vue';
import NewProfile from '@/pages/Bizminer/Profiles/NewProfile.vue';
import NewMarketProfile from '@/pages/Bizminer/Profiles/NewMarketProfile.vue';
import NewValuationReport from '@/pages/Bizminer/Profiles/NewValuationReport.vue';
import NewCompanyReport from '@/pages/Bizminer/Profiles/NewCompanyReport.vue';
import Favotites from '@/pages/Bizminer/Favorites.vue';

// IF Report
import IFFinanicalReport from '@/pages/Bizminer/Reports/IFReport/IFFinanicalReport.vue';
import IFIndustrySummary from '@/pages/Bizminer/Reports/IFReport/IFIndustrySummary.vue';
import IFProfitLoss from '@/pages/Bizminer/Reports/IFReport/IFProfitLoss.vue';
import IFBalanceSheetReport from '@/pages/Bizminer/Reports/IFReport/IFBalanceSheetReport.vue';
import IFCashRatiosVariance from '@/pages/Bizminer/Reports/IFReport/IFRatios/IFCashRatiosVariance.vue';
import IFProfitabilityVariance from '@/pages/Bizminer/Reports/IFReport/IFRatios/IFProfitabilityVariance.vue';
import IFEfficiencyVariance from '@/pages/Bizminer/Reports/IFReport/IFRatios/IFEfficiencyVariance.vue';
import IFDebtRiskVariance from '@/pages/Bizminer/Reports/IFReport/IFRatios/IFDebtRiskVariance.vue';
import IFReportSourcesUsers from '@/pages/Bizminer/Reports/IFReport/IFSourcesUses.vue';
import IFReportValuationMultiples from '@/pages/Bizminer/Reports/IFReport/IFValuationMultiples.vue';
import IFAboutTheData from '@/pages/Bizminer/Reports/IFReport/IFAboutTheData.vue';
import IFCustomizeReport from '@/pages/Bizminer/Reports/IFReport/IFCustomizeReport.vue';
import IFManageInputs from '@/pages/Bizminer/Reports/IFReport/IFManageInputs.vue';
import FinancialRatios from '@/pages/Bizminer/Reports/IFReport/FinancialRatios.vue';

// SPIF Report
import SPIFFinanicalReport from '@/pages/Bizminer/Reports/SPIFReport/SPIFFinanicalReport.vue';
import SPIFIndustrySummary from '@/pages/Bizminer/Reports/SPIFReport/SPIFIndustrySummary.vue';
import SPIFProfitLoss from '@/pages/Bizminer/Reports/SPIFReport/SPIFProfitLoss.vue';
import SPIFBalanceSheetReport from '@/pages/Bizminer/Reports/SPIFReport/SPIFBalanceSheetReport.vue';

/*import SPIFCashRatiosVariance from '@/pages/Bizminer/Reports/SPIFReport/SPIFRatios/SPIFCashRatiosVariance.vue';
import SPIFProfitabilityVariance from '@/pages/Bizminer/Reports/SPIFReport/SPIFRatios/SPIFProfitabilityVariance.vue';
import SPIFEfficiencyVariance from '@/pages/Bizminer/Reports/SPIFReport/SPIFRatios/SPIFEfficiencyVariance.vue';
import SPIFDebtRiskVariance from '@/pages/Bizminer/Reports/SPIFReport/SPIFRatios/SPIFDebtRiskVariance.vue';*/


import SPIFCashTables from '@/pages/Bizminer/Reports/SPIFReport/SPIFCashTables.vue';
import SPIFReportValuationMultiples from '@/pages/Bizminer/Reports/SPIFReport/SPIFValuationMultiples.vue';
import SPIFAboutTheData from '@/pages/Bizminer/Reports/SPIFReport/SPIFAboutTheData.vue';
import SPIFCustomizeReport from '@/pages/Bizminer/Reports/SPIFReport/SPIFCustomizeReport.vue';
import SPIFManageInputs from '@/pages/Bizminer/Reports/SPIFReport/SPIFManageInputs.vue';
import SPIFPFinancialRatios from '@/pages/Bizminer/Reports/SPIFReport/SPIFPFinancialRatios.vue';

// Market Report
import MRCompetitiveSummary from '@/pages/Bizminer/Reports/MarketReport/MRCompetitiveSummary.vue';
import MRCompetitors from '@/pages/Bizminer/Reports/MarketReport/MRCompetitors.vue';
import MRMarket from '@/pages/Bizminer/Reports/MarketReport/MRMarket.vue';
import MRAnnualSales from '@/pages/Bizminer/Reports/MarketReport/MRAnnualSales.vue';
import MRCovidImpact from '@/pages/Bizminer/Reports/MarketReport/MRCovidImpact.vue';
import MRPenetration from '@/pages/Bizminer/Reports/MarketReport/MRPenetration.vue';
import MREmployment from '@/pages/Bizminer/Reports/MarketReport/MREmployment.vue';
import MRSalesEmpClasses from '@/pages/Bizminer/Reports/MarketReport/MRSalesEmpClasses.vue';
import MRProductivity from '@/pages/Bizminer/Reports/MarketReport/MRProductivity.vue';
import MRStartups from '@/pages/Bizminer/Reports/MarketReport/MRStartups.vue';
import MRCessation from '@/pages/Bizminer/Reports/MarketReport/MRCessation.vue';
import MROwnership from '@/pages/Bizminer/Reports/MarketReport/MROwnership.vue';
import MRDemographics from '@/pages/Bizminer/Reports/MarketReport/MRDemographics.vue';
import MRAboutTheData from '@/pages/Bizminer/Reports/MarketReport/MRAboutTheData.vue';
import MRManageInputs from '@/pages/Bizminer/Reports/MarketReport/MRManageInputs.vue';
import MRCustomizeReport from '@/pages/Bizminer/Reports/MarketReport/MRCustomizeReport.vue';

//Company Report
import CRSwotSummary from '@/pages/Bizminer/Reports/CompanyReport/CRSwotSummary.vue';
import CRSwotAnalysis from '@/pages/Bizminer/Reports/CompanyReport/CRSwotAnalysis.vue';
import CRFinanicalInsights from '@/pages/Bizminer/Reports/CompanyReport/CRFinanicalInsights.vue';
import CRMarketInsights from '@/pages/Bizminer/Reports/CompanyReport/CRMarketInsights.vue';
import CRCovidImpact from '@/pages/Bizminer/Reports/CompanyReport/CRCovidImpact.vue';
import CRTerms from '@/pages/Bizminer/Reports/CompanyReport/CRTerms.vue';
import CRScoringExplained from '@/pages/Bizminer/Reports/CompanyReport/CRScoringExplained.vue';
import CRAbouttheData from '@/pages/Bizminer/Reports/CompanyReport/CRAbouttheData.vue';
import CRInput from '@/pages/Bizminer/Reports/CompanyReport/CRInput.vue';

//Vestimate Report

import VRBusinessValue from '@/pages/Bizminer/Reports/VestimateReport/VRBusinessValue.vue';
import VRScores from '@/pages/Bizminer/Reports/VestimateReport/VRScores.vue';
import VRCompanyContext from '@/pages/Bizminer/Reports/VestimateReport/VRCompanyContext.vue';
import VRMarketEnvironment from '@/pages/Bizminer/Reports/VestimateReport/VRMarketEnvironment.vue';
import VRFinanicalAnalysis from '@/pages/Bizminer/Reports/VestimateReport/VRFinanicalAnalysis.vue';
import VRKPIDetails from '@/pages/Bizminer/Reports/VestimateReport/VRKPIDetails.vue';
import VRVestimateApproach from '@/pages/Bizminer/Reports/VestimateReport/VRVestimateApproach.vue';
import VRAbouttheData from '@/pages/Bizminer/Reports/VestimateReport/VRAbouttheData.vue';
import VRCustomizeReport from '@/pages/Bizminer/Reports/VestimateReport/VRCustomizeReport.vue';
import VRManageInputs from '@/pages/Bizminer/Reports/VestimateReport/VRManageInputs.vue';

// IF Profile
import IFIntro from '@/pages/Bizminer/Profiles/IFProfile/IFIntro.vue';
import IFProfitAndLoss from '@/pages/Bizminer/Profiles/IFProfile/IFProfitAndLoss.vue';
import IFBalanceSheet from '@/pages/Bizminer/Profiles/IFProfile/IFBalanceSheet.vue';
import IFRatios from '@/pages/Bizminer/Profiles/IFProfile/IFRatios.vue';
import IFSourcesUses from '@/pages/Bizminer/Profiles/IFProfile/IFSourcesUses.vue';
import IFValuationMultiples from '@/pages/Bizminer/Profiles/IFProfile/IFValuationMultiples.vue';
import IFAbout from '@/pages/Bizminer/Profiles/IFProfile/IFAbout.vue';

// IF Profile
import CompanyList from '@/pages/Bizminer/Companies/CompanyList.vue';
import CompanySummary from '@/pages/Bizminer/Companies/CompanySummary.vue';
import AboutTheData from '@/pages/Bizminer/Companies/AboutTheData.vue';

// SPIF Profile
import SPIFIntro from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileIntro.vue';
import SPIFProfitAndLoss from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileProfitAndLoss.vue';
import SPIFBalanceSheet from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileBalanceSheet.vue';
import SPIFRatios from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileRatios.vue';
import SPIFProfileCashTables from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileCashTables.vue';
import SPIFValuationMultiples from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileValuationMultiples.vue';
import SPIFAbout from '@/pages/Bizminer/Profiles/SPIFProfile/SPIFProfileAbout.vue';

// Company Profile
import CompanyProfile from '@/pages/Bizminer/CompanyProfile/CompanyProfile.vue';
import CompanyProfileAuxPage from '@/pages/Bizminer/CompanyProfile/CompanyProfileAuxPage.vue';
import ExtraInformation from '@/pages/Bizminer/CompanyProfile/ExtraInformation.vue';
import FinanicalInsights from '@/pages/Bizminer/CompanyProfile/FinanicalInsights.vue';
import ValueInsights from '@/pages/Bizminer/CompanyProfile/ValueInsights.vue';
import MarketInsights from '@/pages/Bizminer/CompanyProfile/MarketInsights.vue';
import CovidImpact from '@/pages/Bizminer/CompanyProfile/CovidImpact.vue';
import CompanyTerms from '@/pages/Bizminer/CompanyProfile/CompanyTerms.vue';
import CompanyAboutTheData from '@/pages/Bizminer/CompanyProfile/CompanyAboutTheData.vue';
import ValueProposition from '@/pages/Bizminer/CompanyProfile/ValueProposition.vue';
import CompanyDetails from '@/pages/Bizminer/CompanyProfile/CompanyDetails.vue';
import CompanyDescription from '@/pages/Bizminer/CompanyProfile/CompanyDescription.vue';
import CompanyClassifications from '@/pages/Bizminer/CompanyProfile/CompanyClassifications.vue';
import CorporateDetails from '@/pages/Bizminer/CompanyProfile/CorporateDetails.vue';

import CompanyLocation from '@/pages/Bizminer/CompanyProfile/CompanyLocation.vue';
import CompanyLocationDetails from '@/pages/Bizminer/CompanyProfile/CompanyLocationDetails.vue';
import CompanyMailingAddress from '@/pages/Bizminer/CompanyProfile/CompanyMailingAddress.vue';
import CompanyOperatingHours from '@/pages/Bizminer/CompanyProfile/CompanyOperatingHours.vue';
import CompanyPaymentMethod from '@/pages/Bizminer/CompanyProfile/CompanyPaymentMethod.vue';
import ChangeFromUpdateMonth from '@/pages/Bizminer/CompanyProfile/ChangeFromUpdateMonth.vue';
import MonthlyChangeIndex from '@/pages/Bizminer/CompanyProfile/MonthlyChangeIndex.vue';
import CompaniesNarrative from '@/pages/Bizminer/CompanyProfile/CompaniesNarrative.vue';
import CompanyKeyEmployees from '@/pages/Bizminer/CompanyProfile/CompanyKeyEmployees.vue';
import EmailAddressUpsell from '@/pages/Bizminer/CompanyProfile/EmailAddressUpsell.vue';
import CompanyWebPresence from '@/pages/Bizminer/CompanyProfile/CompanyWebPresence.vue';
import CompanySocialMedia from '@/pages/Bizminer/CompanyProfile/CompanySocialMedia.vue';
import CompanyAdvertisingTags from '@/pages/Bizminer/CompanyProfile/CompanyAdvertisingTags.vue';
import CompanyBrands from '@/pages/Bizminer/CompanyProfile/CompanyBrands.vue';
import CompanyBankruptcyProfile from '@/pages/Bizminer/CompanyProfile/CompanyBankruptcyProfile.vue';
import CompanyCredit from '@/pages/Bizminer/CompanyProfile/CompanyCredit.vue';
import CompanyBenefitPlans from '@/pages/Bizminer/CompanyProfile/CompanyBenefitPlans.vue';
import UccDataUpsell from '@/pages/Bizminer/CompanyProfile/UccDataUpsell.vue';
//import IndustryFinancialInsights from '@/pages/Bizminer/CompanyProfile/IndustryFinancialInsights.vue';

// Market Profile
import Competitors from '@/pages/Bizminer/Profiles/MarketProfile/Competitors.vue';
import Market from '@/pages/Bizminer/Profiles/MarketProfile/Market.vue';
import AnnualSales from '@/pages/Bizminer/Profiles/MarketProfile/AnnualSales.vue';
import MarketProfileCovid from '@/pages/Bizminer/Profiles/MarketProfile/MarketProfileCovid.vue';
import Penetration from '@/pages/Bizminer/Profiles/MarketProfile/Penetration.vue';
import Employment from '@/pages/Bizminer/Profiles/MarketProfile/Employment.vue';
import SalesEmpClasses from '@/pages/Bizminer/Profiles/MarketProfile/SalesEmpClasses.vue';
import Productivity from '@/pages/Bizminer/Profiles/MarketProfile/Productivity.vue';
import Startups from '@/pages/Bizminer/Profiles/MarketProfile/Startups.vue';
import Cessation from '@/pages/Bizminer/Profiles/MarketProfile/Cessation.vue';
import Ownership from '@/pages/Bizminer/Profiles/MarketProfile/Ownership.vue';
import Demographics from '@/pages/Bizminer/Profiles/MarketProfile/Demographics.vue';
import MarketAboutTheData from '@/pages/Bizminer/Profiles/MarketProfile/MarketAboutTheData.vue';

import FindCompanies from '@/pages/Bizminer/Favorites/FindCompanies.vue';
import MyReports from '@/pages/Bizminer/Reports/MyReports.vue';
import MyProspectList from '@/pages/Bizminer/Profiles/MyProspectList.vue';
import NewReport from '@/pages/Bizminer/Reports/NewReport.vue';
import CreateNewReport from '@/pages/Bizminer/Reports/CreateNewReport.vue';
import CreateReportFormat from '@/pages/Bizminer/Reports/CreateReportFormat.vue';
import MyData from '@/pages/Bizminer/Inputs/MyData.vue';
import InputDetails from '@/pages/Bizminer/Inputs/InputDetails.vue';
import EditMyData from '@/pages/Bizminer/Inputs/EditMyData.vue';
import BillingAndInvoices from '@/pages/Bizminer/UserProfile/BillingAndInvoices.vue';
import ImpersonateUser from '@/pages/Bizminer/UserProfile/ImpersonateUser.vue';
import BVR from '@/pages/Bizminer/UserProfile/BVR.vue';
import TransactionDetails from '@/pages/Bizminer/UserProfile/TransactionDetails.vue';
import Subscriptions from '@/pages/Bizminer/UserProfile/Subscriptions/Subscriptions.vue';
import Cart from '@/pages/Bizminer/Cart.vue';
import Checkout from '@/pages/Bizminer/Checkout.vue';
import CheckoutSuccess from '@/pages/Bizminer/CheckoutSuccess.vue';
import ValuationMultiple from '@/pages/Bizminer/Reports/ValuationMultiple/ValuationMultiple.vue';

// Pages
import User from '@/pages/Bizminer/UserProfile.vue';
import Pricing from '@/pages/Bizminer/Pricing.vue';
import TimeLine from '@/pages/Bizminer/TimeLinePage.vue';
import RtlSupport from '@/pages/Bizminer/RtlSupport.vue';
import Login from '@/pages/Bizminer/Login.vue';
import Logout from '@/pages/Bizminer/Logout.vue';
import Register from '@/pages/Bizminer/Register.vue';
import EmailSent from '@/pages/Bizminer/EmailSent.vue';
import EmailConfirm from '@/pages/Bizminer/EmailConfirm.vue';
import ForgotPassword from '@/pages/Bizminer/ForgotPassword.vue';
import RecoverPassword from '@/pages/Bizminer/RecoverPassword.vue';
import Lock from '@/pages/Bizminer/Lock.vue';

// Maps pages
import GoogleMaps from '@/pages/Dashboard/Maps/GoogleMaps.vue';
import FullScreenMap from '@/pages/Dashboard/Maps/FullScreenMap.vue';
import VectorMaps from '@/pages/Dashboard/Maps/VectorMaps.vue';

//import middleware
import auth from '@/middleware/auth';
import guest from '@/middleware/guest';
import academic from '@/middleware/academic';
import entryFinancialProfile from '@/middleware/entry-financial-profile';
import entryCompanyReport from '@/middleware/entry-company-report';
import entryCompanyProfile from '@/middleware/entry-company-profile';
import entryFinancialReport from '@/middleware/entry-financial-report';
import entryMarketProfile from '@/middleware/entry-market-profile';
import entryMarketReport from '@/middleware/entry-market-report';
import entryProspectList from '@/middleware/entry-prospect-list';
import entryValuationReport from '@/middleware/entry-valuation-report';

import ContactUs from '@/pages/Bizminer/ContactUs.vue';
import Privacy from '@/pages/Bizminer/Privacy.vue';
import Terms from '@/pages/Bizminer/Terms.vue';

// Testing items:
import testbed from '@/pages/testbed.vue';

const authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [{
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
    },
    {
        path: '/email-sent',
        name: 'EmailSent',
        component: EmailSent,
    },
    {
        path: '/email-confirm/:id/:token',
        name: 'EmailConfirm',
        component: EmailConfirm,
    },
    {
        path: '/password-reminder',
        name: 'ForgotPassword',
        component: ForgotPassword,
    },
    {
        path: '/password-recover/:hash',
        name: 'RecoverPassword',
        component: RecoverPassword,
    },
    {
        path: '/team-claim/:hash/:email',
        name: 'RecoverPassword',
        component: RecoverPassword,
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: Pricing,
    },
    {
        path: '/lock',
        name: 'Lock',
        component: Lock,
    },
    ],
};

let developmentPages = {
    path: '/dev/',
    component: DashboardLayout,
    redirect: { name: 'Testbed' },
    meta: { middleware: auth },
    children: [
        { path: 'testbed', name: 'Testbed', components: {default: testbed}, meta: {middleware: auth} }
    ]
};

const financialReports = {
    path: '/finanical-report/:id/',
    component: ReportLayout,
    redirect: { name: 'IFFinanicalReport' },
    meta: { middleware: auth },
    children: [{
        path: 'summary-score',
        name: 'IFFinanicalReport',
        components: { default: IFFinanicalReport },
        meta: { middleware: auth },
    },
    {
        path: 'industry-summary',
        name: 'IFIndustrySummary',
        components: { default: IFIndustrySummary },
        meta: { middleware: auth },
    },
    {
        path: 'profit-loss',
        name: 'IFProfitLoss',
        components: { default: IFProfitLoss },
        meta: { middleware: auth },
    },
    {
        path: 'balance-sheet-report',
        name: 'IFBalanceSheetReport',
        components: { default: IFBalanceSheetReport },
        meta: { middleware: auth },
    },
    {
        path: 'cash-ratios-variance',
        name: 'IFCashRatiosVariance',
        components: { default: IFCashRatiosVariance },
        meta: { middleware: auth },
    },
    {
        path: 'profitability-ratios-variance',
        name: 'IFProfitabilityVariance',
        components: { default: IFProfitabilityVariance },
        meta: { middleware: auth },
    },
    {
        path: 'efficiency-ratios-variance',
        name: 'IFEfficiencyVariance',
        components: { default: IFEfficiencyVariance },
        meta: { middleware: auth },
    },
    {
        path: 'debt-risky-ratios-variance',
        name: 'IFDebtRiskVariance',
        components: { default: IFDebtRiskVariance },
        meta: { middleware: auth },
    },
    {
        path: 'sources-users',
        name: 'IFReportSourcesUsers',
        components: { default: IFReportSourcesUsers },
        meta: { middleware: auth },
    },
    {
        path: 'valuation-multiples',
        name: 'IFReportValuationMultiples',
        components: { default: IFReportValuationMultiples },
        meta: { middleware: auth },
    },
    {
        path: 'about-data',
        name: 'IFAboutTheData',
        components: { default: IFAboutTheData },
        meta: { middleware: auth },
    },
    {
        path: 'customize-report',
        name: 'IFCustomizeReport',
        components: { default: IFCustomizeReport },
        meta: { middleware: auth },
    },
    {
        path: 'manage-inputs',
        name: 'IFManageInputs',
        components: { default: IFManageInputs },
        meta: { middleware: auth },
    },
    {
        path: 'financial-ratios',
        name: 'FinancialRatios',
        components: { default: FinancialRatios },
        meta: { middleware: auth },
    },
    ],
};
const soleProprietorshipFinancialReports = {
    path: '/sole-proprietorship-finanical-report/:id/',
    component: ReportLayout,
    redirect: { name: 'SPIFFinanicalReport' },
    meta: { middleware: auth },
    children: [{
        path: 'summary-score',
        name: 'SPIFFinanicalReport',
        components: { default: SPIFFinanicalReport },
        meta: { middleware: auth },
    },
    {
        path: 'industry-summary',
        name: 'SPIFIndustrySummary',
        components: { default: SPIFIndustrySummary },
        meta: { middleware: auth },
    },

    {
        path: 'financial-ratios',
        name: 'FinancialRatios',
        components: { default: SPIFPFinancialRatios },
        meta: { middleware: auth },
    },

    {
        path: 'profit-loss',
        name: 'SPIFProfitLoss',
        components: { default: SPIFProfitLoss },
        meta: { middleware: auth },
    },
    {
        path: 'balance-sheet-report',
        name: 'SPIFBalanceSheetReport',
        components: { default: SPIFBalanceSheetReport },
        meta: { middleware: auth },
    },
    /*{
        path: 'cash-ratios-variance',
        name: 'SPIFCashRatiosVariance',
        components: { default: SPIFCashRatiosVariance },
        meta: { middleware: auth },
    },
    {
        path: 'profitability-ratios-variance',
        name: 'SPIFProfitabilityVariance',
        components: { default: SPIFProfitabilityVariance },
        meta: { middleware: auth },
    },
    {
        path: 'efficiency-ratios-variance',
        name: 'SPIFEfficiencyVariance',
        components: { default: SPIFEfficiencyVariance },
        meta: { middleware: auth },
    },
    {
        path: 'debt-risky-ratios-variance',
        name: 'SPIFDebtRiskVariance',
        components: { default: SPIFDebtRiskVariance },
        meta: { middleware: auth },
    },*/
    {
        path: 'cash-tables',
        name: 'SPIFCashTables',
        components: { default: SPIFCashTables },
        meta: { middleware: auth },
    },
    {
        path: 'valuation-multiples',
        name: 'SPIFReportValuationMultiples',
        components: { default: SPIFReportValuationMultiples },
        meta: { middleware: auth },
    },
    {
        path: 'about-data',
        name: 'SPIFAboutTheData',
        components: { default: SPIFAboutTheData },
        meta: { middleware: auth },
    },
    {
        path: 'customize-report',
        name: 'SPIFCustomizeReport',
        components: { default: SPIFCustomizeReport },
        meta: { middleware: auth },
    },
    {
        path: 'manage-inputs',
        name: 'SPIFManageInputs',
        components: { default: SPIFManageInputs },
        meta: { middleware: auth },
    },
    ],
};
const entryRoutes = {
    path: '/entry/',
    children: [{
        path: 'industry-financial-profile',
        name: 'EntryFinancialProfile',
        meta: { middleware: [entryFinancialProfile] },
    },
    {
        path: 'industry-market-profile',
        name: 'EntryMarketProfile',
        meta: { middleware: [entryMarketProfile] },
    },
    {
        path: 'company-profile',
        name: 'EntryCompanyProfile',
        meta: { middleware: [entryCompanyProfile] },
    },
    {
        path: 'prospect-list',
        name: 'EntryProspectList',
        meta: { middleware: [entryProspectList] },
    },
    {
        path: 'financial-report',
        name: 'EntryFinancialReport',
        meta: { middleware: [entryFinancialReport] },
    },
    {
        path: 'market-report',
        name: 'EntryMarketReport',
        meta: { middleware: [entryMarketReport] },
    },
    {
        path: 'valuation-report',
        name: 'EntryValuationReport',
        meta: { middleware: [entryValuationReport] },
    },
    {
        path: 'company-report',
        name: 'EntryCompanyReport',
        meta: { middleware: [entryCompanyReport] },
    },
    ]

};
const sampleFinancialProfile = {
    path: '/sample/industry-financial-profile',
    component: SampleProfileLayout,
    redirect: { name: 'SampleIFAbout' },
    children: [{
        path: 'introduction',
        name: 'IFIntro',
        components: { default: IFIntro },
    },
    {
        path: 'financial-fundamentals',
        name: 'IFProfitAndLoss',
        components: { default: IFProfitAndLoss },
    },
    {
        path: 'balance-sheet',
        name: 'IFBalanceSheet',
        components: { default: IFBalanceSheet },
    },
    {
        path: 'ratios',
        name: 'IFRatios',
        components: { default: IFRatios },
    },
    {
        path: 'sources-users',
        name: 'IFSourcesUses',
        components: { default: IFSourcesUses },
    },
    {
        path: 'valuation-multiples',
        name: 'IFValuationMultiples',
        components: { default: IFValuationMultiples },
    },
    {
        path: 'about',
        name: 'SampleIFAbout',
        components: { default: IFAbout },
    },
    ]
};
const sampleMarketProfile = {
    path: '/sample/industry-market-profile',
    component: SampleMarketProfileLayout,
    redirect: { name: 'SampleMarketAboutTheData' },
    children: [{
        path: 'competitors',
        name: 'Competitors',
        components: { default: Competitors },
    },
    {
        path: 'market',
        name: 'Market',
        components: { default: Market },
    },
    {
        path: 'annual-sales',
        name: 'AnnualSales',
        components: { default: AnnualSales },
    },
    {
        path: 'covid-impact',
        name: 'MarketProfileCovid',
        components: { default: MarketProfileCovid },
    },
    {
        path: 'penetration',
        name: 'MarketProfileCovid',
        components: { default: Penetration },
    },
    {
        path: 'employment',
        name: 'MarketProfileCovid',
        components: { default: Employment },
    },
    {
        path: 'sales-emp-classes',
        name: 'SalesEmpClasses',
        components: { default: SalesEmpClasses },
    },
    {
        path: 'productivity',
        name: 'Productivity',
        components: { default: Productivity },
    },
    {
        path: 'startups',
        name: 'Startups',
        components: { default: Startups },
    },
    {
        path: 'cessation',
        name: 'Startups',
        components: { default: Cessation },
    },
    {
        path: 'ownership',
        name: 'Startups',
        components: { default: Ownership },
    },
    {
        path: 'demographics',
        name: 'Startups',
        components: { default: Demographics },
    },
    {
        path: 'about-the-data',
        name: 'SampleMarketAboutTheData',
        components: { default: MarketAboutTheData },
    },
    ],
};
const sampleCompanyProfile = {
    path: '/sample/company-profile',
    component: SampleCompanyProfileLayout,
    redirect: { name: 'SampleCompanyAboutTheData' },
    children: [{
        path: 'profile',
        name: 'CompanyDetails',
        components: { default: CompanyProfile },
    },
    {
        path: 'extra-information',
        name: 'ExtraInformation',
        components: { default: ExtraInformation },
    },
    {
        path: 'finanical-insights',
        name: 'FinanicalInsights',
        components: { default: FinanicalInsights },
    },
    {
        path: 'value-insights',
        name: 'ValueInsights',
        components: { default: ValueInsights },
    },
    {
        path: 'market-insights',
        name: 'MarketInsights',
        components: { default: MarketInsights },
    },
    {
        path: 'covid-impact',
        name: 'COVIDImpact',
        components: { default: CovidImpact },
    },
    {
        path: 'company-contacts',
        name: 'CompanyKeyEmployees',
        components: { default: CompanyKeyEmployees },
    },
    {
        path: 'web-presence',
        name: 'CompanyWebPresence',
        components: { default: CompanyWebPresence },
    },
    {
        path: 'credit',
        name: 'CompanyCredit',
        components: { default: CompanyCredit },
    },
    {
        path: 'company-about-the-data',
        name: 'SampleCompanyAboutTheData',
        components: { default: CompanyAboutTheData },
    },
    ],
};
const sampleFinancialReport = {
    path: '/sample/financial-report',
    component: SampleFinancialReportLayout,
    redirect: { name: 'SampleIFAboutTheData' },
    children: [{
        path: 'summary-score',
        name: 'IFFinanicalReport',
        components: { default: IFFinanicalReport },
    },
    {
        path: 'industry-summary',
        name: 'IFIndustrySummary',
        components: { default: IFIndustrySummary },
    },
    {
        path: 'profit-loss',
        name: 'IFProfitLoss',
        components: { default: IFProfitLoss },
    },
    {
        path: 'balance-sheet-report',
        name: 'IFBalanceSheetReport',
        components: { default: IFBalanceSheetReport },
    },
    {
        path: 'cash-ratios-variance',
        name: 'IFCashRatiosVariance',
        components: { default: IFCashRatiosVariance },
    },
    {
        path: 'profitability-ratios-variance',
        name: 'IFProfitabilityVariance',
        components: { default: IFProfitabilityVariance },
    },
    {
        path: 'efficiency-ratios-variance',
        name: 'IFEfficiencyVariance',
        components: { default: IFEfficiencyVariance },
    },
    {
        path: 'debt-risky-ratios-variance',
        name: 'IFDebtRiskVariance',
        components: { default: IFDebtRiskVariance },
    },
    {
        path: 'sources-users',
        name: 'IFReportSourcesUsers',
        components: { default: IFReportSourcesUsers },
    },
    {
        path: 'valuation-multiples',
        name: 'IFReportValuationMultiples',
        components: { default: IFReportValuationMultiples },
    },
    {
        path: 'about-data',
        name: 'SampleIFAboutTheData',
        components: { default: IFAboutTheData },
    },
    {
        path: 'customize-report',
        name: 'IFCustomizeReport',
        components: { default: IFCustomizeReport },
    },
    {
        path: 'manage-inputs',
        name: 'IFManageInputs',
        components: { default: IFManageInputs },
    },
    {
        path: 'financial-ratios',
        name: 'FinancialRatios',
        components: { default: FinancialRatios },
    },
    ],
};
const sampleMarketReport = {
    path: '/sample/market-report',
    component: SampleMarketReportLayout,
    redirect: { name: 'SampleMRAboutTheData' },
    children: [{
        path: 'competitive-summary',
        name: 'SampleMRCompetitiveSummary',
        components: { default: MRCompetitiveSummary },
    },
    {
        path: 'market-rep-competitors',
        name: 'MRCompetitors',
        components: { default: MRCompetitors },
    },
    {
        path: 'market-rep-market',
        name: 'MRMarket',
        components: { default: MRMarket },
    },
    {
        path: 'market-rep-annual-sales',
        name: 'MRAnnualSales',
        components: { default: MRAnnualSales },
    },
    {
        path: 'market-rep-covid-impact',
        name: 'MRCovidImpact',
        components: { default: MRCovidImpact },
    },
    {
        path: 'market-rep-penetration',
        name: 'MRPenetration',
        components: { default: MRPenetration },
    },
    {
        path: 'market-rep-employment',
        name: 'MREmployment',
        components: { default: MREmployment },
    },
    {
        path: 'market-rep-sales',
        name: 'MRSalesEmpClasses',
        components: { default: MRSalesEmpClasses },
    },
    {
        path: 'market-rep-productivity',
        name: 'MRProductivity',
        components: { default: MRProductivity },
    },
    {
        path: 'market-rep-startups',
        name: 'MRStartups',
        components: { default: MRStartups },
    },
    {
        path: 'market-rep-cessation',
        name: 'MRCessation',
        components: { default: MRCessation },
    },
    {
        path: 'market-rep-ownership',
        name: 'MROwnership',
        components: { default: MROwnership },
    },
    {
        path: 'market-rep-demographics',
        name: 'MRDemographics',
        components: { default: MRDemographics },
    },
    {
        path: 'market-rep-about-data',
        name: 'SampleMRAboutTheData',
        components: { default: MRAboutTheData },
    },
    {
        path: 'manage-inputs',
        name: 'MRManageInputs',
        components: { default: MRManageInputs },
    },
    {
        path: 'customize-report',
        name: 'MRCustomizeReport',
        components: { default: MRCustomizeReport },
    },
    ],
};
const sampleCompanyReport = {
    path: '/sample/company-report',
    component: SampleCompanyReportLayout,
    redirect: { name: 'SampleCRAbouttheData' },
    children: [{
        path: 'swot-summary',
        name: 'CRSwotSummary',
        components: { default: CRSwotSummary },
    },
    {
        path: 'swot-analysis',
        name: 'CRSwotAnalysis',
        components: { default: CRSwotAnalysis },
    },
    {
        path: 'finanical-insights',
        name: 'CRFinanicalInsights',
        components: { default: CRFinanicalInsights },
    },
    {
        path: 'market-insights',
        name: 'CRMarketInsights',
        components: { default: CRMarketInsights },
    },
    {
        path: 'covid-impact',
        name: 'CRCovidImpact',
        components: { default: CRCovidImpact },
    },
    {
        path: 'terms',
        name: 'CRTerms',
        components: { default: CRTerms },
    },
    {
        path: 'scoring-explained',
        name: 'CRScoringExplained',
        components: { default: CRScoringExplained },
    },
    {
        path: 'report-about-the-data',
        name: 'SampleCRAbouttheData',
        components: { default: CRAbouttheData },
    },
    {
        path: 'report-input',
        name: 'CRInput',
        components: { default: CRInput },
    },
    ],
};
const sampleVestimateReport = {
    path: '/sample/valuation-report',
    component: SampleVestimateReportLayout,
    redirect: { name: 'SampleVRAbouttheData' },
    children: [{
        path: 'business-value',
        name: 'VRBusinessValue',
        components: { default: VRBusinessValue },
    },
    {
        path: 'scores',
        name: 'VRScores',
        components: { default: VRScores },
    },
    {
        path: 'Company-Context',
        name: 'VRCompanyContext',
        components: { default: VRCompanyContext },
    },
    {
        path: 'Market-Environment',
        name: 'VRMarketEnvironment',
        components: { default: VRMarketEnvironment },
    },
    {
        path: 'finanical-analysis',
        name: 'VRFinanicalAnalysis',
        components: { default: VRFinanicalAnalysis },
    },
    {
        path: 'kpi-details',
        name: 'VRKPIDetails',
        components: { default: VRKPIDetails },
    },
    {
        path: 'vestimate-approach',
        name: 'VRVestimateApproach',
        components: { default: VRVestimateApproach },
    },
    {
        path: 'customize-report',
        name: 'VRAbouttheDataV',
        components: { default: VRAbouttheData },
    },
    {
        path: 'vestimate-report-about-data',
        name: 'SampleVRAbouttheData',
        components: { default: VRAbouttheData },
    },
    {
        path: 'vestimate-customize-report',
        name: 'VRCustomizeReport',
        components: { default: VRCustomizeReport },
    },
    {
        path: 'vestimate-manage-inputs',
        name: 'VRManageInputs',
        components: { default: VRManageInputs },
    },
    ],
};

const routes = [
    authPages,
    financialReports,
    soleProprietorshipFinancialReports,
    sampleVestimateReport,
    sampleFinancialReport,
    sampleMarketReport,
    sampleCompanyReport,
    sampleFinancialProfile,
    sampleMarketProfile,
    sampleCompanyProfile,
    entryRoutes,
    developmentPages,
    {
        path: '/',
        component: DashboardLayout,
        meta: { middleware: auth },
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            components: { default: Dashboard },
            meta: { middleware: auth },
        },
        {
            path: 'search',
            name: 'Search',
            components: { default: Search },
            meta: { middleware: auth },
        },
        {
            path: 'company-search',
            name: 'CompanySearch',
            components: { default: CompanySearch },
            meta: { middleware: auth },
        },
        {
            path: 'my-profiles',
            name: 'MyProfiles',
            components: { default: MyProfiles },
            meta: { middleware: auth },
        },
        {
            path: 'new-profile',
            name: 'NewProfiles',
            components: { default: NewProfiles },
            meta: { middleware: auth },
        },
        {
            path: 'new-profile/industry-market-profile',
            name: 'NewMarketProfile',
            components: { default: NewMarketProfile },
            meta: { middleware: auth },
        },
        {
            path: 'new-profile/industry-financial-profile',
            name: 'NewProfile',
            components: { default: NewProfile },
            meta: { middleware: auth },
        },
        {
            path: 'new-profile/valuation-report',
            name: 'NewValuationReport',
            components: { default: NewValuationReport },
            meta: { middleware: auth },
        },
        {
            path: 'new-profile/company-report',
            name: 'NewCompanyReport',
            components: { default: NewCompanyReport },
            meta: { middleware: auth },
        },
        {
            path: 'new-profile/:id',
            name: 'NewProfile',
            components: { default: NewProfile },
            meta: { middleware: auth },
        },
        {
            path: 'my-reports',
            name: 'MyReports',
            components: { default: MyReports },
            meta: { middleware: academic },
        },
        {
            path: 'my-prospect-lists',
            name: 'MyProspectList',
            components: { default: MyProspectList },
            meta: { middleware: academic },
        },
        {
            path: 'new-report',
            name: 'NewReport',
            components: { default: NewReport },
            meta: { middleware: auth },
        },
        {
            path: 'create-new-report',
            name: 'CreateNewReport',
            components: { default: CreateNewReport },
            meta: { middleware: auth },
        },
        {
            path: 'create-report-format/:report',
            name: 'CreateReportFormat',
            components: { default: CreateReportFormat },
            meta: { middleware: academic },
        },
        {
            path: 'create-report-format',
            name: 'CreateReportFormat',
            components: { default: CreateReportFormat },
            meta: { middleware: academic },
        },
        {
            path: 'valuation-multiple',
            name: 'ValuationMultiple',
            components: { default: ValuationMultiple },
            meta: { middleware: auth },
        },
        {
            path: 'find-companies',
            name: 'FindCompanies',
            components: { default: FindCompanies },
            meta: { middleware: auth },
        },
        {
            path: 'prospect',
            name: 'ProspectList',
            components: { default: FindCompanies },
            meta: { middleware: auth },
        },
        {
            path: 'my-data',
            name: 'MyData',
            components: { default: MyData },
            meta: { middleware: academic },
        },
        {
            path: 'input',
            name: 'InputDetails',
            components: { default: InputDetails },
            meta: { middleware: auth },
        },
        {
            path: 'my-data/:id',
            name: 'EditMyData',
            components: { default: EditMyData },
            meta: { middleware: auth },
        },
        {
            path: 'my-account',
            name: 'UserPage',
            components: { default: User },
            meta: { middleware: academic },
        },
        {
            path: 'billing-and-invoices',
            name: 'BillingAndInvoices',
            components: { default: BillingAndInvoices },
            meta: { middleware: auth },
        },
        {
            path: 'cart',
            name: 'Cart',
            components: { default: Cart },
            meta: { middleware: academic },
        },
        {
            path: 'checkout',
            name: 'Checkout',
            components: { default: Checkout },
            meta: { middleware: auth },
        },
        {
            path: 'checkout-success',
            name: 'CheckoutSuccess',
            components: { default: CheckoutSuccess },
            meta: { middleware: auth },
        },
        {
            path: 'transaction/:tid',
            name: 'TransactionDetails',
            components: { default: TransactionDetails },
            meta: { middleware: auth },
        },
        {
            path: 'subscriptions',
            name: 'Subscriptions',
            components: { default: Subscriptions },
            meta: { middleware: auth },
        },
        /*{
            path: 'calendar',
            name: 'Calendar',
            components: { default: Calendar },
            meta: { middleware: auth },
        },*/
        /*{
            path: 'charts',
            name: 'Charts',
            components: { default: Charts },
            meta: { middleware: auth },
        },*/
        /*{
            path: 'widgets',
            name: 'Widgets',
            components: { default: Widgets },
            meta: { middleware: auth },
        },*/

        {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy,
            meta: { middleware: auth },
        },
        {
            path: '/terms',
            name: 'Terms',
            component: Terms,
            meta: { middleware: auth },
        },
        {
            path: '/contact',
            name: 'ContactUs',
            component: ContactUs,
            meta: { middleware: auth },
        },
        {
            path: 'my-favorites',
            name: 'Favorites',
            components: { default: Favotites },
            meta: { middleware: auth },
        },
        ],
    },
    {
        path: '/prospect-search',
        name: 'ProspectSearch',
        components: { default: ProspectSearch },
        meta: { middleware: academic },
    },
    {
        path: '/search-list/:id/:total',
        name: 'SearchList',
        components: { default: SearchList },
        meta: { middleware: auth },
    },
    {
        path: '/if/:id/',
        component: ProfileLayout,
        redirect: { name: 'IFIntro' },
        meta: { middleware: auth },
        children: [{
            path: 'introduction',
            name: 'IFIntro',
            components: { default: IFIntro },
            meta: { middleware: auth },
        },
        {
            path: 'financial-fundamentals',
            name: 'IFProfitAndLoss',
            components: { default: IFProfitAndLoss },
            meta: { middleware: auth },
        },
        {
            path: 'balance-sheet',
            name: 'IFBalanceSheet',
            components: { default: IFBalanceSheet },
            meta: { middleware: auth },
        },
        {
            path: 'ratios',
            name: 'IFRatios',
            components: { default: IFRatios },
            meta: { middleware: auth },
        },
        {
            path: 'sources-users',
            name: 'IFSourcesUses',
            components: { default: IFSourcesUses },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-multiples',
            name: 'IFValuationMultiples',
            components: { default: IFValuationMultiples },
            meta: { middleware: auth },
        },
        {
            path: 'about',
            name: 'IFAbout',
            components: { default: IFAbout },
            meta: { middleware: auth },
        },
        ],
    },
    {
        path: '/spif/:id/',
        component: ProfileLayout,
        redirect: { name: 'SPIFIntro' },
        meta: { middleware: auth },
        children: [{
            path: 'introduction',
            name: 'SPIFIntro',
            components: { default: SPIFIntro },
            meta: { middleware: auth },
        },
        {
            path: 'profit-and-loss',
            name: 'SPIFProfitAndLoss',
            components: { default: SPIFProfitAndLoss },
            meta: { middleware: auth },
        },
        {
            path: 'balance-sheet',
            name: 'SPIFBalanceSheet',
            components: { default: SPIFBalanceSheet },
            meta: { middleware: auth },
        },
        {
            path: 'ratios',
            name: 'SPIFRatios',
            components: { default: SPIFRatios },
            meta: { middleware: auth },
        },
        {
            path: 'cash-tables',
            name: 'SPIFCashTables',
            components: { default: SPIFProfileCashTables },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-multiples',
            name: 'SPIFValuationMultiples',
            components: { default: SPIFValuationMultiples },
            meta: { middleware: auth },
        },
        {
            path: 'about',
            name: 'SPIFAbout',
            components: { default: SPIFAbout },
            meta: { middleware: auth },
        },
        ],
    },
    {
        path: '/',
        component: CompanyLayout,
        meta: { middleware: auth },
        children: [{
            path: 'companies/:id/list',
            name: 'CompaniesList',
            components: { default: CompanyList },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/company-summary',
            name: 'CompanySummary',
            components: { default: CompanySummary },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/about-the-data',
            name: 'AboutTheData',
            components: { default: AboutTheData },
            meta: { middleware: auth },
        },
            // {
            //   path: 'companies/:id/report-about-the-data',
            //   name: 'IFIntro',
            //   components: { default: AboutTheData },
            //   meta: { middleware: auth },
            // },
        ],
    },
    {
        path: '/',
        component: CompanyProfileLayout,
        meta: { middleware: auth },
        children: [{
            path: 'companies/:id/profile',
            name: 'CompanyProfile',
            components: { default: CompanyProfile },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/profile/auxpage',
            name: 'CompanyProfileAuxPage',
            components: { default: CompanyProfileAuxPage },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/extra-information',
            name: 'ExtraInformation',
            components: { default: ExtraInformation },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/finanical-insights',
            name: 'FinanicalInsights',
            components: { default: FinanicalInsights },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/value-insights',
            name: 'ValueInsights',
            components: { default: ValueInsights },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/market-insights',
            name: 'MarketInsights',
            components: { default: MarketInsights },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/month-to-month-employment-sales',
            name: 'COVIDImpact',
            components: { default: CovidImpact },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/change-from-update-month',
            name: 'ChangeFromUpdateMonth',
            components: { default: ChangeFromUpdateMonth },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/monthly-change-index',
            name: 'MonthlyChangeIndex',
            components: { default: MonthlyChangeIndex },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/companies-narrative',
            name: 'CompaniesNarrative',
            components: { default: CompaniesNarrative },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/company-terms',
            name: 'CompanyTerms',
            components: { default: CompanyTerms },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/company-about-the-data',
            name: 'CompanyAboutTheData',
            components: { default: CompanyAboutTheData },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/value-proposition',
            name: 'ValueProposition',
            components: { default: ValueProposition },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/company-details',
            name: 'CompanyDetails',
            components: { default: CompanyDetails },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/company-description',
            name: 'CompanyDescription',
            components: { default: CompanyDescription },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/company-classifications',
            name: 'CompanyClassifications',
            components: { default: CompanyClassifications },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/corporate-details',
            name: 'CorporateDetails',
            components: { default: CorporateDetails },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/company-location',
            name: 'CompanyLocation',
            components: { default: CompanyLocation },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/location-details',
            name: 'CompanyLocationDetails',
            components: { default: CompanyLocationDetails },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/mailing-address',
            name: 'CompanyMailingAddress',
            components: { default: CompanyMailingAddress },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/operating-hours',
            name: 'CompanyOperatingHours',
            components: { default: CompanyOperatingHours },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/payment-methods',
            name: 'CompanyPaymentMethod',
            components: { default: CompanyPaymentMethod },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/key-employees',
            name: 'CompanyKeyEmployees',
            components: { default: CompanyKeyEmployees },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/email-addresses-upsell',
            name: 'EmailAddressUpsell',
            components: { default: EmailAddressUpsell },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/web-presence',
            name: 'CompanyWebPresence',
            components: { default: CompanyWebPresence },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/social-media',
            name: 'CompanySocialMedia',
            components: { default: CompanySocialMedia },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/advertising-tags',
            name: 'CompanyAdvertisingTags',
            components: { default: CompanyAdvertisingTags },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/Brands',
            name: 'CompanyBrands',
            components: { default: CompanyBrands },
            meta: { middleware: auth },
        },

        {
            path: 'companies/:id/credit',
            name: 'CompanyCredit',
            components: { default: CompanyCredit },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/bankruptcy-profile',
            name: 'CompanyBankruptcyProfile',
            components: { default: CompanyBankruptcyProfile },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/benefit-plans',
            name: 'CompanyBenefitPlans',
            components: { default: CompanyBenefitPlans },
            meta: { middleware: auth },
        },
        {
            path: 'companies/:id/ucc-data-upsell',
            name: 'UccDataUpsell',
            components: { default: UccDataUpsell },
            meta: { middleware: auth },
        },
        ],
    },
    {
        path: '/industry-market-profile/:id/',
        component: MarketProfileLayout,
        redirect: { name: 'Competitors' },
        meta: { middleware: auth },
        children: [{
            path: 'competitors',
            name: 'Competitors',
            components: { default: Competitors },
            meta: { middleware: auth },
        },
        {
            path: 'market',
            name: 'Market',
            components: { default: Market },
            meta: { middleware: auth },
        },
        {
            path: 'annual-sales',
            name: 'AnnualSales',
            components: { default: AnnualSales },
            meta: { middleware: auth },
        },
        {
            path: 'covid-impact',
            name: 'MarketProfileCovid',
            components: { default: MarketProfileCovid },
            meta: { middleware: auth },
        },
        {
            path: 'penetration',
            name: 'MarketProfileCovid',
            components: { default: Penetration },
            meta: { middleware: auth },
        },
        {
            path: 'employment',
            name: 'MarketProfileCovid',
            components: { default: Employment },
            meta: { middleware: auth },
        },
        {
            path: 'sales-emp-classes',
            name: 'SalesEmpClasses',
            components: { default: SalesEmpClasses },
            meta: { middleware: auth },
        },
        {
            path: 'productivity',
            name: 'Productivity',
            components: { default: Productivity },
            meta: { middleware: auth },
        },
        {
            path: 'startups',
            name: 'Startups',
            components: { default: Startups },
            meta: { middleware: auth },
        },
        {
            path: 'cessation',
            name: 'Startups',
            components: { default: Cessation },
            meta: { middleware: auth },
        },
        {
            path: 'ownership',
            name: 'Startups',
            components: { default: Ownership },
            meta: { middleware: auth },
        },
        {
            path: 'demographics',
            name: 'Startups',
            components: { default: Demographics },
            meta: { middleware: auth },
        },
        {
            path: 'about-the-data',
            name: 'MarketAboutTheData',
            components: { default: MarketAboutTheData },
            meta: { middleware: auth },
        },
        ],
    },
    /*{
      path: '/finanical-report/:id/',
      component: ReportLayout,
      redirect: { name: 'MRCompetitiveSummary' },
      meta: { middleware: auth },
      children: [
        {
          path: 'competitive-summary',
          name: 'MRCompetitiveSummary',
          components: { default: MRCompetitiveSummary },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-competitors',
          name: 'MRCompetitors',
          components: { default: MRCompetitors },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-market',
          name: 'MRMarket',
          components: { default: MRMarket },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-annual-sales',
          name: 'MRAnnualSales',
          components: { default: MRAnnualSales },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-covid-impact',
          name: 'MRCovidImpact',
          components: { default: MRCovidImpact },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-penetration',
          name: 'MRPenetration',
          components: { default: MRPenetration },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-employment',
          name: 'MREmployment',
          components: { default: MREmployment },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-sales',
          name: 'MRSalesEmpClasses',
          components: { default: MRSalesEmpClasses },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-productivity',
          name: 'MRProductivity',
          components: { default: MRProductivity },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-startups',
          name: 'MRStartups',
          components: { default: MRStartups },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-cessation',
          name: 'MRCessation',
          components: { default: MRCessation },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-ownership',
          name: 'MROwnership',
          components: { default: MROwnership },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-demographics',
          name: 'MRDemographics',
          components: { default: MRDemographics },
          meta: { middleware: auth },
        },
        {
          path: 'market-rep-about-data',
          name: 'MRAboutTheData',
          components: { default: MRAboutTheData },
          meta: { middleware: auth },
        },
      ],
    },*/
    {
        path: '/market-report/:id/',
        component: MarketReportLayout,
        redirect: { name: 'MRCompetitiveSummary' },
        meta: { middleware: auth },
        children: [{
            path: 'competitive-summary',
            name: 'MRCompetitiveSummary',
            components: { default: MRCompetitiveSummary },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-competitors',
            name: 'MRCompetitors',
            components: { default: MRCompetitors },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-market',
            name: 'MRMarket',
            components: { default: MRMarket },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-annual-sales',
            name: 'MRAnnualSales',
            components: { default: MRAnnualSales },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-covid-impact',
            name: 'MRCovidImpact',
            components: { default: MRCovidImpact },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-penetration',
            name: 'MRPenetration',
            components: { default: MRPenetration },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-employment',
            name: 'MREmployment',
            components: { default: MREmployment },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-sales',
            name: 'MRSalesEmpClasses',
            components: { default: MRSalesEmpClasses },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-productivity',
            name: 'MRProductivity',
            components: { default: MRProductivity },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-startups',
            name: 'MRStartups',
            components: { default: MRStartups },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-cessation',
            name: 'MRCessation',
            components: { default: MRCessation },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-ownership',
            name: 'MROwnership',
            components: { default: MROwnership },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-demographics',
            name: 'MRDemographics',
            components: { default: MRDemographics },
            meta: { middleware: auth },
        },
        {
            path: 'market-rep-about-data',
            name: 'MRAboutTheData',
            components: { default: MRAboutTheData },
            meta: { middleware: auth },
        },
        {
            path: 'manage-inputs',
            name: 'MRManageInputs',
            components: { default: MRManageInputs },
            meta: { middleware: auth },
        },
        {
            path: 'customize-report',
            name: 'MRCustomizeReport',
            components: { default: MRCustomizeReport },
            meta: { middleware: auth },
        },
        ],
    },
    {
        path: '/conference/ibba2022/impersonate/:id',
        name: 'ImpersonateUser',
        components: { default: ImpersonateUser },
        //meta: { middleware: auth },
    },
    {
        path: '/conference/ibba2022/impersonateAndRedirect/:id',
        name: 'ImpersonateUser',
        components: { default: ImpersonateUser },
        //meta: { middleware: auth },
    },
    {
        path: '/bvr/:prod/:id/:ts/:key/:ornum/:endsub/:state',
        name: 'BVR',
        components: { default: BVR },
        //meta: { middleware: auth },
    },
    {
        path: '/',
        component: CompanyReportLayout,
        meta: { middleware: auth },
        children: [{
            path: 'company-report/:id/swot-summary',
            name: 'CRSwotSummary',
            components: { default: CRSwotSummary },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/swot-analysis',
            name: 'CRSwotAnalysis',
            components: { default: CRSwotAnalysis },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/finanical-insights',
            name: 'CRFinanicalInsights',
            components: { default: CRFinanicalInsights },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/market-insights',
            name: 'CRMarketInsights',
            components: { default: CRMarketInsights },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/covid-impact',
            name: 'CRCovidImpact',
            components: { default: CRCovidImpact },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/terms',
            name: 'CRTerms',
            components: { default: CRTerms },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/scoring-explained',
            name: 'CRScoringExplained',
            components: { default: CRScoringExplained },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/report-about-the-data',
            name: 'CRAbouttheData',
            components: { default: CRAbouttheData },
            meta: { middleware: auth },
        },
        {
            path: 'company-report/:id/report-input',
            name: 'CRInput',
            components: { default: CRInput },
            meta: { middleware: auth },
        },
        ],
    },
    {
        path: '/',
        component: VestimateReportLayout,
        meta: { middleware: auth },
        children: [{
            path: 'valuation-report/:id/business-value',
            name: 'VRBusinessValue',
            components: { default: VRBusinessValue },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/scores',
            name: 'VRScores',
            components: { default: VRScores },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/Company-Context',
            name: 'VRCompanyContext',
            components: { default: VRCompanyContext },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/Market-Environment',
            name: 'VRMarketEnvironment',
            components: { default: VRMarketEnvironment },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/finanical-analysis',
            name: 'VRFinanicalAnalysis',
            components: { default: VRFinanicalAnalysis },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/kpi-details',
            name: 'VRKPIDetails',
            components: { default: VRKPIDetails },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/vestimate-approach',
            name: 'VRVestimateApproach',
            components: { default: VRVestimateApproach },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/customize-report',
            name: 'VRAbouttheDataV',
            components: { default: VRAbouttheData },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/vestimate-report-about-data',
            name: 'VRAbouttheData',
            components: { default: VRAbouttheData },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/vestimate-customize-report',
            name: 'VRCustomizeReport',
            components: { default: VRCustomizeReport },
            meta: { middleware: auth },
        },
        {
            path: 'valuation-report/:id/vestimate-manage-inputs',
            name: 'VRManageInputs',
            components: { default: VRManageInputs },
            meta: { middleware: auth },
        },
        ],
    }
];

export default routes;